import Vue from 'vue'
import {apiUrl, alert} from '../helper'
import $ from 'jquery'
// import wx from 'weixin-js-sdk'
import VipDialogView from '../components/Search/VipDialog.vue'

export default {
  data () {
    return {
      currentuser: null,
      shareUsername: '',     // 用户名，用于搜索结果分享
      uid: null,
      xnName:null,
      company:null,
      position:null,
      headUrl:null,
      showUserInfo:false,
    }
  },
  methods: {
    getProfile (share) {
      let shared;
      if(share != 'weixin'){
        shared = share.share
        console.log(share)
        if(!share.showuserinfo || share.showuserinfo == 0){
          this.showUserInfo = false;
        } else {
          this.showUserInfo = true;
        }
      } else {
        shared = share
      }
      console.log('分享出去的信息')
      $.ajax({
        url: apiUrl('/V1.0.0/user/profile'),
        method: 'post',
        dataType: 'json',
        async: false
      }).done((response) => {
        if (response.status === 0) {
          this.currentuser = response.data;
          if(share != 'weixin'){
            console.log('获取用户信息')
            this.uid = share.uid
            this.userInfo(this.uid)
          }
          this.shareUsername = response.data.username
          this.currentRegtyp = response.data.regtyp
          if (response.data.regtyp === 4) {
            // 绑定微信
            this.showTipGoBind()
          }
        }
        if (response.status === 403 && shared === 'weixin') {      // 未登录
          let appid = this.$config.weixin.appid
          let redirectUri = encodeURIComponent(window.location.href)
          window.location.href = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' + appid + '&redirect_uri=' + redirectUri + '&response_type=code&scope=snsapi_userinfo&state=123#wechat_redirect'
        }
      }).fail((response) => {
        console.log('请求失败')
      })
    },
    userInfo: function(id){
      let query = {}
      query.uid = id;
      $.ajax({
        url: apiUrl('/V1.0.0/user/userinfo'),
        method: 'post',
        dataType: 'json',
        data: JSON.stringify(query)
      }).done((response) =>{
        let info = response.data;
        this.company = info.company;
        this.position = info.title;
        this.headUrl = info.headimgurl;
        if(info.realname){
          this.xnName = info.realname
          return false;
        } else if(info.wx_nickname){
          this.xnName = info.wx_nickname
          return false;
        }
      })
    },
    logout () {
      $.ajax({
        url: apiUrl('/V1.0.0/user/logout'),
        method: 'post',
        dataType: 'json'
      }).done((response) => {
        if (response.status === 0) {
          this.$route.router.go('/login')
        }
      }).fail((response) => {
        alert('请求失败')
      })
    },

    /**
     * 权限检查
     * @param  { String }  code [指定权限名称]
     * @return { Boolean }      true/false
     */
    checkAction (code) {
      // console.log('checkAction')
      if (this.currentuser) {
        // if (this.currentuser.actions.indexOf(code) !== -1) {
        //   return true
        // } else {
        //   return false
        // }
        let flag = false;
        for (let i=0; i< this.currentuser.actions.length; i++) {
          if (this.currentuser.actions[i] == code) {
            flag = true
            break;
          }
        }
        return flag;
      } else {
        // console.log('no currentuser')
        return true;
      }
    },
    // 权限检查
    checkPrivilege (code, message) {
      // console.log('checkPrivilege')
      if (!this.checkAction(code)) {
        let Ins = Vue.extend(VipDialogView)
        let ins = new Ins({
          el: document.createElement('div'),
          data () {
            return {
              message: message,
              showflag: true,
              currentuser: this.currentuser
            }
          },
          methods: {
            close (event) {
              ins.$remove()
            }
          }
        })
        ins.$appendTo(document.body)
        return false
      } else {
        return true
      }
    },

  },
}



/** WEBPACK FOOTER **
 ** ./src/common/userMix.js
 **/